import './App.css';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './Containers/home';
import About from './Containers/about';
import Contact from './Containers/contact';
import Portfolio from './Containers/portfolio';
import Resume from './Containers/resume';
import Skills from './Containers/skills';
import Navbar from './Components/navbar';

function App() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return <div className="App">
    <a className="skip-link" href="#main">Skip to content</a>
    <Navbar />
    <main id="main" className="page-shell"><Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/skills" element={<Skills />} />
      <Route path="/resume" element={<Resume />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<section className="inner-page"><h1>Page not found.</h1><Link className="button" to="/">Back to home</Link></section>} />
    </Routes></main>
    <footer className="footer"><span>© {new Date().getFullYear()} Rahul Kumar Chaudhary</span><span>Built with care. <a href="https://github.com/N-rahul-35" target="_blank" rel="noreferrer">GitHub ↗</a><a href="https://linkedin.com/in/rahul-kumar-417671252/" target="_blank" rel="noreferrer">LinkedIn ↗</a></span></footer>
  </div>;
}
export default App;
